'use client'

import 'dayjs/locale/en'

import { ApolloNextAppProvider as ApolloProvider } from '@apollo/experimental-nextjs-app-support'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import relativeTime from 'dayjs/plugin/relativeTime'
import React from 'react'

import { makeApolloClient } from '../service/apollo.client'
import { getQueryClient } from '../service/query-client'

dayjs.extend(duration)
dayjs.extend(relativeTime)

type ProvidersProps = {
  children: React.ReactNode
}

function Providers(props: ProvidersProps) {
  return (
    <ApolloProvider makeClient={makeApolloClient}>
      <QueryClientProvider client={getQueryClient()}>
        {props.children}
        <ReactQueryDevtools />
      </QueryClientProvider>
    </ApolloProvider>
  )
}

export default Providers
